import React from "react";

import { Navigate } from "react-router-dom";

import { useStandalonePerformanceAccess } from "src/performance/useStandalonePerformanceAccess";
import { FlowPageParams, getFlowSubpageUrl } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

type Props = {
  children: React.ReactNode;
};

export const PerformanceRouteGuard: React.FC<Props> = ({ children }) => {
  const { isEnabled, isLoading } = useStandalonePerformanceAccess();
  const { orgId, wsId, flow_id: flowId } = useParamsDecode<FlowPageParams>();

  if (isLoading) {
    return null;
  }

  if (isEnabled) {
    return <>{children}</>;
  }

  return (
    <Navigate
      replace
      to={getFlowSubpageUrl(orgId, wsId, flowId, "analytics")}
    />
  );
};
